import React from "react";
import { ReactComponent as ActiveScheduleIconSvg } from "../../images/command-hub/ActiveScheduleIcon.svg";
import { SvgIcon, SvgIconProps } from "@mui/material";

const ActiveScheduleIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon component={ActiveScheduleIconSvg} {...props} inheritViewBox />
)

export default ActiveScheduleIcon;